import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelModeratorsCommand, } from "../commands/ListChannelModeratorsCommand";
export const paginateListChannelModerators = createPaginator(ChimeSDKMessagingClient, ListChannelModeratorsCommand, "NextToken", "NextToken", "MaxResults");
